import {Pipe, PipeTransform} from '@angular/core';
import {CompetitorResultsDetail, MeasurementPrecisionTypes, MeasurementTypes} from '@model';
import {milisecondsToPrecision, removeLeadingZeros, stringTimeToPrecision} from "@utility";

@Pipe({
    name: 'resultsTotalTime',
    standalone: false
})
export class TotalTimePipe implements PipeTransform {

  transform(competitorResultsDetail: CompetitorResultsDetail | undefined, measurementType?: MeasurementTypes | undefined, measurementPrecisionType?: MeasurementPrecisionTypes | undefined, ignorePenalty: boolean = false): string {
    measurementPrecisionType = measurementPrecisionType ?? MeasurementPrecisionTypes.SECONDS;
    return removeLeadingZeros(stringTimeToPrecision(TotalTimePipe.getTotalTime(competitorResultsDetail, measurementType, ignorePenalty).replace(".000", ""), measurementPrecisionType));
  }

  public static getTotalTime(competitorResultsDetail: CompetitorResultsDetail | undefined, measurementType: MeasurementTypes | undefined | MeasurementTypes.GUN_TIME_ONLY | MeasurementTypes.GUN_TIME_PRIMARY | MeasurementTypes.CHIP_TIME_PRIMARY | MeasurementTypes.EXTERNAL_IMPORT, ignorePenalty: boolean = false) {
    if (!competitorResultsDetail) {
      return '-';
    }
    const precomputedTotalTime = ignorePenalty ? competitorResultsDetail?.display_time_no_penalty : competitorResultsDetail.display_time;

    if (precomputedTotalTime !== undefined && precomputedTotalTime !== null) {
      return precomputedTotalTime;
    }

    if (measurementType === MeasurementTypes.CHIP_TIME_ONLY || measurementType === MeasurementTypes.CHIP_TIME_PRIMARY) {
      if (!ignorePenalty && competitorResultsDetail.tl_ch_tm_pen !== undefined && competitorResultsDetail.tl_ch_tm_pen !== null) {
        return competitorResultsDetail.tl_ch_tm_pen;
      } else if (competitorResultsDetail.tl_ch_tm !== undefined && competitorResultsDetail.tl_ch_tm !== null) {
        return competitorResultsDetail.tl_ch_tm;
      } else {
        return TotalTimePipe.getGunTotalTime(competitorResultsDetail, ignorePenalty);
      }
    } else {
      return TotalTimePipe.getGunTotalTime(competitorResultsDetail, ignorePenalty);
    }
  }

  public static getGunTotalTime(competitorResultsDetail: CompetitorResultsDetail, ignorePenalty: boolean = false) {
    if (!ignorePenalty && competitorResultsDetail.tl_tm_pen !== undefined && competitorResultsDetail.tl_tm_pen !== null) {
      return competitorResultsDetail.tl_tm_pen;
    } else if (competitorResultsDetail.tl_tm !== undefined && competitorResultsDetail.tl_tm !== null) {
      return competitorResultsDetail.tl_tm;
    } else {
      return '-';
    }
  }
}
